import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { NavLink, Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }


  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* <li>
              <NavLink
                exact
                activeClassName="mm-active"
                to="/home"
                className=""
              >
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Home")}</span>
              </NavLink>
            </li> */}
            <li>
              <NavLink activeClassName="mm-active" to="/projects">
                <i className="bx bx-folder"></i>
                <span className="text-body bold font-size-16">{props.t("Projects")}</span>
              </NavLink>
            </li>
            <li>
              <div>
                <span className="text-body bold font-size-16"></span>
              </div>
            </li>
            <li>
              <NavLink activeClassName="mm-active" to="/analyze" className="">
                <i className="bx bx-chart"></i>
                <span className="text-body bold font-size-16">{props.t("Analytics")}</span>
              </NavLink>
            </li>
            <li>
              <div>
                <span className="text-body bold font-size-16"></span>
              </div>
            </li>
            <li>
              <NavLink activeClassName="mm-active" to="/idea" className="">
                <i className="bx bx-bulb"></i>
                <span className="text-body bold font-size-16">{props.t("Ideas")}</span>
              </NavLink>
            </li>
            <li>
              <div>
                <span className="text-body bold font-size-16"></span>
              </div>
            </li>
            {/*<li>*/}
            {/*  <NavLink activeClassName="mm-active" to="/hub" className="">*/}
            {/*    <i className="bx bx-group"></i>*/}
            {/*    <span>{props.t("Hub")}</span>*/}
            {/*  </NavLink>*/}
            {/*</li>*/}
           {/*  <li>
              <NavLink activeClassName="mm-active" to="/calendar" className="">
                <i className="bx bx-calendar"></i>
                <span>{props.t("Calendar")}</span>
              </NavLink>
            </li> */}
            <li>
              <NavLink activeClassName="mm-active" to="/portfolio" className="">
                <i className="bx bx-chalkboard"></i>
                <span className="text-body bold font-size-16">{props.t("Portfolio")}</span>
              </NavLink>
            </li>
            <li></li>
           {/*  <li>
              <NavLink activeClassName="mm-active" to="/screenplays" className="">
                <i className="bx bx-edit"></i>
                <span>{props.t("Screenplay")}</span>
              </NavLink>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
